import '@talon/web/src/styles/animations.css';
import '@talon/web/src/styles/globals.css';
import { Grommet } from 'grommet';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ChatWidget, ErrorFallback } from 'src/components';
import { RootContextProvider } from 'src/context';
import { config } from './config';
import { AppRoutes } from './routes';
import theme from './theme';
import { WEB_RELEASE } from './utils/release';

// Visible in devtools and read by the post-deploy smoke tests to confirm which build is live
window.__TALON_RELEASE__ = WEB_RELEASE;
console.info(`Talon web ${WEB_RELEASE}`);

const { posthog } = config.env;
const root = document.getElementById('app');
root &&
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <PostHogProvider apiKey={posthog.api_key || ''} options={posthog.options}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <RootContextProvider>
            <BrowserRouter>
              <Grommet theme={theme} className="grommet-container">
                <AppRoutes />
                <ChatWidget />
                <ToastContainer position="bottom-right" />
              </Grommet>
            </BrowserRouter>
          </RootContextProvider>
        </ErrorBoundary>
      </PostHogProvider>
    </React.StrictMode>
  );
